import { logger as garnishLogger } from '@garnish/logger';

// ─────────────────────────────────────────────────────────────────────────────

// garnishLogger.enable('LOCATION STATE MACHINE');

export const locationSearchLogger = garnishLogger.extend('LOCATION STATE MACHINE');
